import { BaseInternalApi } from '../baseApi';

export class PriviaApi extends BaseInternalApi {
  public async getLaunchUrl(): Promise<{ url: string } | undefined> {
    const httpClient = this.getHttpClient();

    const { data } = await httpClient.get('/api/v2/launchUrl');

    return data.url;
  }
}
